import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  breadcrumbs: null,
};

const utilsSlice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    setBreadcrumbs: (state, { payload }) => {
      state.breadcrumbs = payload;
    },
  },
});

export const { setBreadcrumbs } = utilsSlice.actions;
export default utilsSlice.reducer;
